import { render, staticRenderFns } from "./dentalAccounting.vue?vue&type=template&id=5f9e8db7&scoped=true&"
import script from "./dentalAccounting.vue?vue&type=script&lang=js&"
export * from "./dentalAccounting.vue?vue&type=script&lang=js&"
import style0 from "./dentalAccounting.vue?vue&type=style&index=0&id=5f9e8db7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9e8db7",
  null
  
)

export default component.exports